import React, { Component } from 'react';
// import { BarChart, Bar, XAxis, YAxis, Cell } from 'recharts';
import './style.css';
import { translate } from 'react-i18next';

class End extends Component {
  constructor(props) {
    super(props);
    this.state = {
      interview: JSON.stringify(props.state.output, null, 4),
      response: ''
    };
    this.sendData = this.sendData.bind(this);
  }

  sendData() {
    const payload = {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.props.state.output)
    };

    fetch(
      process.env.REACT_APP_API_URL + '/backend/interview/api/create/',
      payload
    )
      .then(function(response) {
        return response.json();
      })
      .then(
        function(json) {
          // this.setState({ response: json['page_0'] });
          this.setState({ response: json['id'] });
        }.bind(this)
      )
      .catch(function(ex) {
        console.log('parsing failed', ex);
      });
  }

  componentDidMount() {
    this.sendData();
  }

  render() {
    const { t } = this.props;
    let message = t('Your results are being submitted!');
    if (this.state.response) {
      message = t('Your interview ID is') + ': ' + this.state.response;
    }
    return (
      <div style={{ textAlign: 'center', paddingTop: '2em' }}>
        <h3>{t('Thank you for participating')}!</h3>
        {message}
      </div>
    );
  }

  // render() {
  //   const transformation = obj => {
  //     let color = 'green';
  //     if (obj.score < 0) {
  //       color = 'red';
  //     }

  //     return Object.assign(
  //       {},
  //       {
  //         y: obj.score,
  //         name: obj.object_name,
  //         color: color,
  //         oid: obj.oid
  //       }
  //     );
  //   };

  //   let series = [];
  //   if (this.state.response) {
  //     series = this.state.response.map(function(row) {
  //       return transformation(row);
  //     });
  //   }

  //   return (
  //     <div style={{ fontFamily: 'sans-serif', fontSize: '0.8em' }}>
  //       <BarChart
  //         width={400}
  //         height={350}
  //         data={series}
  //         layout="vertical"
  //         margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
  //         barCategoryGap="30%"
  //       >
  //         <XAxis type="number" hide={true} />
  //         <YAxis
  //           type="category"
  //           dataKey="name"
  //           axisLine={false}
  //           tickLine={false}
  //         />
  //         <YAxis
  //           yAxisId={1}
  //           type="category"
  //           orientation="right"
  //           dataKey="y"
  //           axisLine={false}
  //           tickLine={false}
  //         />
  //         <Bar dataKey="y">
  //           {series.map((entry, index) => (
  //             <Cell fill={series[index].y < 0 ? 'red' : 'green'} />
  //           ))}
  //         </Bar>
  //       </BarChart>
  //     </div>
  //   );
  // }
}

export default translate('translations')(End);



// WEBPACK FOOTER //
// ./src/comparison/components/End/index.js